import { Component, Input } from '@angular/core';

@Component({
  selector: 'libero-description-dropdown',
  templateUrl: './description-dropdown.component.html',
  styleUrls: ['./description-dropdown.component.scss'],
  standalone: false
})
export class DescriptionDropdownComponent {
  public toggled = false;
  @Input() public riskScore?: number;

  public toggle(): void {
    this.toggled = !this.toggled;
  }

}
